import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const BadgeContainer = styled.div`
  position: absolute;
  top: 80px;
  left: 112px;
  z-index: 10;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  margin-top: 8px;
  margin-left: auto;
  border: 1px solid ${colors.brand.primary.base};
  border-radius: 4px;
  background-color: transparent;
  color: ${colors.brand.primary.base};
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  width: 214px;
  height: 30px;
  opacity: 1;
  text-transform: uppercase;
`;
